var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Inputs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Password",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 18V12C34 8.68629 31.3137 6 28 6C24.6863 6 22 8.68629 22 12V18H34ZM16 12V18H10C6.68629 18 4 20.6863 4 24V50C4 53.3137 6.68629 56 10 56H46C49.3137 56 52 53.3137 52 50V24C52 20.6863 49.3137 18 46 18H40V12C40 5.37258 34.6274 0 28 0C21.3726 0 16 5.37258 16 12ZM34 24H40H46V50H10V24H16H22H34ZM28 45C32.4183 45 36 41.4183 36 37C36 32.5817 32.4183 29 28 29C23.5817 29 20 32.5817 20 37C20 41.4183 23.5817 45 28 45Z",
    fill: "#BFC4CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.3c6020879ac633c2f5e10ba3c9e9b8a4.svg";
export { ForwardRef as ReactComponent };